import {saveData, getData, clearData, findByID} from "../db/db_helper"

//load from DB
export const getOnlineProducts = async () =>{
    return await getData("products") || []
}

export const getOffllineProducts = async () =>{
    return await getData("sync_products") || []
}

export const getAllProducts = async () =>{
    const online = await getOnlineProducts()
    const offline = await getOffllineProducts()
    const all = [...online, ...offline]
    return all.sort((a, b) => a.index - b.index);
}

export const getProductsByCategorie = async(id) =>{
    const all = await getAllProducts()
    return all.filter(p => p.categoryId === id )
}

export const getProductById = async(id)=>{
    const online = await findByID("products", id)
    const offline = await findByID("sync_products", id)
    return online || offline || null
}

export const saveProducts = async (obj) =>{
    saveData("products", obj)
}

export const getProductIndex = (id, productArray)=>{
    return productArray.findIndex(o => o.id === id);
}

export const clearSyncProducts = () =>{
    clearData("sync_products")
}

export const updateProductInventory = async(id, inventory) =>{
    try {
            const target = await getProductById(id)
            target.availableStock = inventory;
            const localData = await getOffllineProducts()
    
            let index = -1
            const serverData = await getOnlineProducts()
            index = await getProductIndex(id, serverData)
            if(index !== -1){
                serverData.splice(index, 1)
                await saveData("products", serverData)
                localData.push(target)
                await saveData("sync_products", localData)
                return true
            } 
    
            index = await getProductIndex(id, localData)
            if(index !== -1){
                localData[index] = target
                await saveData("sync_products", localData)
                return true
            } 
            return false;
    
        } catch (error) {
            console.error("Fehler bei offline Order Creation:", error);
            return null;
        }
}